var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loading"},[_c('img',{attrs:{"src":_vm.logoImg,"alt":"Omint"}}),_c('p',[_vm._v(_vm._s(_vm.step))])])}
var staticRenderFns = []

export { render, staticRenderFns }